export const RootAPI = 'https://ilcorda-api.nec-fts.com/api/'
// export const RootAPI = 'https://ilcordatest-api.nec-fts.com/api/'
export const PartnerAPI = 'https://ilcorda-api.nec-fts.com/api/'
// export const RootAPI = 'https://172.30.47.118:5001/api/'
//export const RootAPI = 'https://172.30.47.118:5004/api/'
// export const RootAPI = 'https://demoapi.nec-fts.com/api/'




